import React from 'react';
export function ProblemSection() {
  return <section className="w-full bg-black py-16 px-4 pt-[0px] pb-[0px]" data-id="element-289">
      <div className="max-w-3xl mx-auto text-center" data-id="element-290">
        <h2 className="text-2xl sm:text-3xl font-bold text-white mb-10" data-id="element-291">
          Si sos docente de Italiano en Argentina,
          <br data-id="element-292" />
          <span className="text-[#00C853]" data-id="element-293">esto te va a sonar familiar:</span>
        </h2>

        <div className="space-y-4 text-left mb-12" data-id="element-294">
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-295">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-296">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-297">
              Domingo a la noche buscando actividades en internet que nunca
              quedan bien, están en italiano demasiado avanzado o no se adaptan
              al alumno argentino que recién empieza
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-298">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-299">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-300">
              Llegás al lunes con algo que "más o menos sirve" y durante la
              clase te das cuenta que le falta estructura, cierre, solucionario
              y evaluación
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-301">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-302">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-303">
              Tenés que armar planificaciones para jefatura o dirección del
              instituto a las corridas, la noche anterior, sin saber si están
              bien formuladas para el nivel MCER
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-304">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-305">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-306">
              Tus evaluaciones son siempre las mismas o siempre inventadas
              porque no tenés un banco de instrumentos serios con solucionario
              incluido
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-307">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-308">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-309">
              Cuando el tema es difícil —el Congiuntivo, el Periodo Ipotetico,
              los Pronomi Combinati— no sabés cómo explicarlo sin perder al
              grupo en el camino
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-310">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-311">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-312">
              Tenés alumnos con niveles muy distintos en el mismo grupo (A2 con
              B1) y no tenés material diferenciado — así que das para el
              promedio y perdés a todos
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-313">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-314">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-315">
              El material que encontrás online está en italiano demasiado
              formal, no conecta con la cultura italiana real y encima está
              incompleto
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-316">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-317">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-318">
              Trabajás de lunes a viernes, llegás al fin de semana agotado/a y
              el domingo volvés a empezar el ciclo de buscar, armar e improvisar
            </p>
          </div>
        </div>

        <p className="text-[#00C853] text-2xl sm:text-3xl font-black mb-8" data-id="element-319">
          ¿Cuántos domingos más vas a perder haciendo lo mismo?
        </p>

        {/* Green divider */}
        <div className="h-px bg-gradient-to-r from-transparent via-[#00C853] to-transparent w-full" data-id="element-320" />
      </div>
    </section>;
}